<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs3-07",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 48,
      nextPage: '/questionnaire/section3/8',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'longBtn'
        },
        mainTitle: 'How often do you drink coffee per week?',
        btn: [
          [
            {
              text: 'Over 1 cup a day',
              operation: 'flag3-1_Anything_add suggestion 10 & flag1-4_Prepare_add reminder 3'
            }
          ],[
            {
              text: '1 cup per day',
              operation: 'flag1-4_Prepare_add reminder 3'
            }
          ],[
            {
              text: '2 to 3 cups a week',
            }
          ],[
            {
              text: '1 to 2 cups a week',
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
